module.exports = __webpack_public_path__ + "front/img/73.2e611b74.png";